/** Rutas de auth y endpoints públicos que no llevan Bearer. */
export function isPublicAuthApiUrl(url: string): boolean {
  const base = url.split('?')[0];
  return (
    base.includes('/auth/login') ||
    base.includes('/auth/setup-required') ||
    /\/auth\/setup$/.test(base) ||
    /\/publico\/expediente\//.test(base) ||
    /\/publico\/perfil\//.test(base) ||
    /\/publico\/geo\//.test(base) ||
    /\/publico\/firma-documentos\//.test(base) ||
    /\/firma-ficha\/descarga/.test(base) ||
    /\/firma\/descarga/.test(base)
  );
}
